// extracted by mini-css-extract-plugin
export var alignCenter = "_9g-d";
export var bannerShown = "_9g-6";
export var buttonContent = "_9g-0";
export var cardList = "_9g-1";
export var centerContent = "_9g-2";
export var chevron = "_9g-3";
export var closePanelButton = "_9g-k";
export var conversationContextContainer = "_9g-l";
export var conversationDetailContainer = "_9g-4";
export var detailWrapper = "_9g-7";
export var dropdownButton = "_9g-e";
export var dropdownTitle = "_9g-9";
export var fullHeight = "_9g-5";
export var hidden = "_9g-a";
export var icon = "_9g-b";
export var mergeSuggestionWrapper = "_9g-m";
export var panel = "_9g-i";
export var portalButtonsWrapper = "_9g-c";
export var right = "_9g-j";
export var tableSummaryContainer = "_9g-8";
export var tableSummaryHeader = "_9g-g";
export var threeDotsButton = "_9g-f";
export var wide = "_9g-h";